import KambiApi from './kambi-api/kambi-api';
//import KambiApiMock from './kambi-api/kambi-api-mock';
//import InitialState from '../redux/initial-state';
//import cmsMock from "./content-service-api/content-service-mock-api";
import cms from './content-service-api/content-service-api';

export function GetKambiApi() {
  //const {useMockKambiApi} = InitialState.getState().appConfig;
  return /*useMockKambiApi ? KambiApiMock :*/ KambiApi;
}


export function GetContentServiceApi() {
  //const {useMockKambiApi} = InitialState.getState().appConfig;
  return /*useMockKambiApi ? cmsMock :*/ cms;
}
